import { useQuery } from "@tanstack/react-query";
import { logisticsApi } from "./ApiClient";
import { z } from "zod";

export const knownFeatureFlagsSchema = z.enum([
  "unit-test-flag",
  "CarePatientNote",
  "CardiologyWorkflow",
  "Area",
  "AIPlatformAssistantInCenter",
  "SwedishTemporaryIdentityNumber",
  "FE_TemplateManagementModuleEnabled",
  "PERMANENT_UseAbax",
  "PERMANENT_ShowShiftManipulationInUI",
  "ShowPlannedTimeInUI",
  "ShowDurationInUI",
  "FE_EquipmentManagement",
  "CancelVisit",
  "UseSparForPatientRegistration",
  "FE_CapacityOverview",
  "PhoneCallActivityType",
  "GroupClinicVisitActivities",
]);

export const featureFlagSchema = z.object({
  name: knownFeatureFlagsSchema,
  isEnabled: z.boolean(),
});

export type IFeatureFlag = z.infer<typeof featureFlagSchema>;

const featureFlagKeys = {
  all: ["featureFlags"] as const,
  flag: (key: IFeatureFlag["name"]) => ["featureFlag", key] as const,
};

async function getFeatureFlagStatus(key: IFeatureFlag["name"]) {
  return (await logisticsApi.get(`/features/${key}`).json(featureFlagSchema))
    .isEnabled;
}

export const useFeatureFlag = (key: IFeatureFlag["name"]) => {
  return useQuery({
    queryKey: featureFlagKeys.flag(key),
    queryFn: () => getFeatureFlagStatus(key),
  });
};
